import { useQuery } from '@tanstack/react-query';
import { operationsDashboardApi } from '../services/operationsDashboardApi';

// One query per section, so a slow or failed section never holds up the others.
export const useMonthlyKpis = () =>
  useQuery({ queryKey: ['opsPerformance', 'monthlyKpis'], queryFn: operationsDashboardApi.getMonthlyKpis });

export const useSupportingReviews = () =>
  useQuery({ queryKey: ['opsPerformance', 'reviews'], queryFn: () => operationsDashboardApi.getReviews() });

export const useMessageResponse = () =>
  useQuery({ queryKey: ['opsPerformance', 'messageResponse'], queryFn: operationsDashboardApi.getMessageResponse });
